import { flowStatusToCommonTaskStatus } from '@euler/app/flows/task/functions';
import {
  ProgressCardInfoCell,
  ProgressCardView,
} from '@euler/app/tv/components/detail/ProgressCardView';
import { TaskDefectiveChartView } from '@euler/app/tv/components/TaskDefectiveChartView';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { VehicleInspectionFlow } from '@euler/model';
import { TaskDetail } from '@euler/model/task-detail';
import { formatDateTime } from '@euler/utils/formatters';
import { memo } from 'react';
import { StyleProp, Text, ViewStyle } from 'react-native';

const getInspectedCountOfFlow = (detail: TaskDetail, flowId: string) => {
  return (
    detail.inspection.sites.filter(x => x.flowId == null || x.flowId === flowId)
      .length +
    (
      detail.inspection.customIssues?.filter(
        x => x.flowId == null || x.flowId === flowId,
      ) ?? []
    ).length
  );
};

export const InspectionProgressView = memo(
  ({
    detail,
    style,
    onPress,
  }: {
    detail: TaskDetail;
    style?: StyleProp<ViewStyle>;
    onPress?: (flowId?: string) => void;
  }) => {
    return (
      <>
        {detail.inspection.flows.map((flow, index) => (
          <ProgressCardView
            key={flow.id}
            title={flow.name}
            status={flowStatusToCommonTaskStatus(flow.status)}
            statusButtonInProgressText={'检测中'}
            index={index + 1}
            style={style}
            onPress={() => onPress?.(flow.id)}
          >
            <ProgressCardInfoCell
              label="检测技师"
              value={flow.assignedTo.name}
            />
            <ProgressCardInfoCell
              label="派工时间"
              value={formatDateTime(flow.createdAt)}
            />
            <ProgressCardInfoCell
              label="检测结果"
              value={<InlineInspectionResultView detail={detail} flow={flow} />}
            />
          </ProgressCardView>
        ))}
        {detail.inspection.flows.length == 0 && (
          <ProgressCardView
            title={'全车检测'}
            status={detail.inspection.status}
            statusButtonInProgressText={'检测中'}
            index={1}
            style={style}
            onPress={() => onPress?.()}
          >
            <ProgressCardInfoCell label="检测状态" value="未派工" />
            <ProgressCardInfoCell label="派工时间" value="未派工" />
            <ProgressCardInfoCell label="检测结果" value="0" />
          </ProgressCardView>
        )}
      </>
    );
  },
);

const InlineInspectionResultView = memo(
  ({
    detail,
    flow,
    style,
  }: {
    detail: TaskDetail;
    flow: VehicleInspectionFlow;
    style?: StyleProp<ViewStyle>;
  }) => {
    const theme = usePresentationTheme();
    const { rpx } = useResponsiveContext();
    const count = getInspectedCountOfFlow(detail, flow.id);
    if (count === 0) {
      return (
        <Text
          css={`
            font-family: ${FontFamily.NotoSans.Medium};
            color: ${theme.task.detail.card.infoValueColor};
            font-size: ${rpx(28)}px;
          `}
        >
          0
        </Text>
      );
    }
    return (
      <TaskDefectiveChartView
        detail={detail}
        flow={flow}
        size={rpx(40)}
        strokeWidth={rpx(3.5)}
        noLabel
        style={style}
        itemStyle={{
          marginLeft: 0,
          marginRight: rpx(5),
        }}
        counterStyle={{
          fontSize: rpx(15),
        }}
      />
    );
  },
);
